<template>
  <div  class="quick-contact">
    <div class="item">
      <div class="title">
        Ma page Facebook
        <v-svg key="facebook" h="2rem">facebook</v-svg>
      </div>
      <a class="value" href="https://www.facebook.com/stephanie.reflexologie.reiki" target="_blank">Stephanie.reflexologie.reiki</a>
    </div> 
    <div class="item">
      <div class="title">
        Mon adresse email
        <v-svg key="mail" h="2rem">mail</v-svg>
      </div>
      <a class="value" href="mailto:contact.stephanielefebvre62@gmail.com">contact.stephanielefebvre62@gmail.com</a>
    </div>
    <div class="item">
      <div class="title">
        Mon téléphone
        <v-svg key="phone" h="2rem">phone</v-svg>
      </div>
      <span class="value">06 67 75 10 80</span>
    </div>
    <div class="item">
      <div class="title">
        Mon adresse
        <v-svg key="placeholder" h="2rem">placeholder</v-svg>
      </div>
      <span class="value">26 Bis rue Sèche 62400 Essars</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AppQuickContact'
  }
</script>

<style lang="scss" scoped>

  .quick-contact {
    z-index: 1;
    padding: 1em 5em;
    background: #FFFFFF;
    color: #fff;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    justify-items: center;
    font-size: .9em;
    grid-gap: 1em;
    .item {
      color: $color-grey;
      .title {
        display: flex;
        align-items: center;
        margin-bottom: .5em;
        justify-content: center;
        .v-svg {
          margin-left: .5em;
        }
      }
      .value {
        margin: 0;
        color: $color-green;
        font-weight: 500;
      }
    }
  }

</style>
